<template>
  <base-modal name="delete">
    <template #body>
      <div class="mt-50 text-center">
        <div class="my-50">
          <img :src="deleteFullIcon" alt="delete" class="inline" />
        </div>
        <div class="my-50">
          <h6 class="font-semibold text-18 text-title">
            <span class="block">
              {{ $t("are_you_sure_to_delete", { subject: subject }) }}
            </span>
          </h6>
        </div>
      </div>
    </template>
    <template #action>
      <div class="grid grid-cols-2 gap-20">
        <base-button buttonType="cancel" width="167" height="58" @click.native="closeModal" >
          <template #text>
            <span class="text-14">
              {{ $t("cancel") }}
            </span>
          </template>
        </base-button>
        <base-button
          :disabled="disabledButton"
          buttonType="danger"
          width="167"
          height="58"
          @click.native="deleteConfirmed"
        >
          <template #text>
            <span class="text-14">
              {{ $t("delete") }}
            </span>
          </template>
          <template #icon>
            <base-loading />
          </template>
        </base-button>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import BaseLoading from '@/components/base/BaseLoading.vue';
import deleteFull from '@/assets/icons/svg/Delete_Full.svg';
import BaseModal from './BaseModal.vue';

export default {
  name: 'DeleteModal',
  components: {
    BaseModal,
    BaseButton,
    BaseLoading,
  },
  props: {
    subject: {
      type: String,
      default: '',
    },
    disabledButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deleteFullIcon: deleteFull,
    };
  },
  methods: {
    closeModal() {
      this.$emit('cancel');
    },
    deleteConfirmed() {
      this.$emit('deleteConfirmed');
    },
  },
};
</script>
